export const COLUMN_NAME = 'name';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_CREATED_DATE = 'createdDate';
export const COLUMN_ID = 'id';
export const COLUMN_COLOR = 'color';
